module.exports = __webpack_public_path__ + "static/service-roofreplace-2ae3f3a3e2674d17b5259ceed1e33bbb.jpg";